var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilterIcon = function SvgFilterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.555664 0.638672V1.41645C0.556969 1.50804 0.594409 1.5954 0.65983 1.65951L5.71539 6.77062C5.78081 6.83472 5.81825 6.92209 5.81955 7.01367V11.7984C5.81942 11.8635 5.83758 11.9273 5.87196 11.9825C5.90634 12.0378 5.95556 12.0823 6.014 12.1109L8.75705 13.0901C8.81004 13.116 8.86877 13.1281 8.9277 13.125C8.98664 13.122 9.04382 13.104 9.09386 13.0727C9.1439 13.0414 9.18514 12.9979 9.2137 12.9463C9.24225 12.8946 9.25717 12.8366 9.25705 12.7776V6.95117C9.26666 6.85731 9.31129 6.77052 9.38205 6.70812L14.3265 1.67339C14.3919 1.60929 14.4294 1.52193 14.4307 1.43034V0.638672H0.555664Z",
    fill: "#6C757D"
  })));
};
export default SvgFilterIcon;